/** @jsx jsx */
import { useQuery } from '@apollo/client'
import GET_REFRESH_TOKEN from '../../apollo/queries/GET_REFRESH_TOKEN'
import { jsx } from 'theme-ui'
import { func } from 'prop-types'
import { useEffect } from 'react'

const GetRefreshToken = ({ handleGetData }) => {
  const { data } = useQuery(GET_REFRESH_TOKEN(), {
    fetchPolicy: 'network-only',
  })

  useEffect(() => {
    if (data && data.refreshToken) {
      if (handleGetData) {
        handleGetData(data.refreshToken)
      }
      localStorage.setItem('token', data.refreshToken)
    }
  })

  return <div></div>
}

GetRefreshToken.propTypes = {
  handleGetData: func,
}
export default GetRefreshToken
